"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeTemplateHeading = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ChangeTemplateHeading = function (props) {
    var title = props.title, subtitle = props.subtitle, alert = props.alert;
    return (react_1.default.createElement("div", { className: "change-template-heading" },
        react_1.default.createElement("div", { className: "change-template-heading__icon" },
            react_1.default.createElement(icons_1.Integrations, null)),
        react_1.default.createElement("h2", { className: "change-template-heading__title change-template-heading__content" }, title),
        react_1.default.createElement("p", { className: "change-template-heading__subtitle change-template-heading__content" }, subtitle),
        alert && (react_1.default.createElement(kaleidoscope_1.Alert, { className: "change-template-heading__alert", heading: undefined }, alert))));
};
exports.ChangeTemplateHeading = ChangeTemplateHeading;
